// src/utils/teamKey.js
//
// Team-Identität im Frontend an einem Ort.
//
// Seit der Umstellung auf stabile IDs wird ausschliesslich ueber `team_id`
// verglichen; `team_name` ist reine Anzeige und darf sich aendern. Alle
// Vergleiche (Ergebniszuordnung, React-Keys, Fortschrittszaehler) muessen
// deshalb ueber diese Helfer laufen und niemals ueber den Namen.
//
// Die Rueckfaelle auf `team_name`/`team` decken Datenbestaende ab, die vor der
// Umstellung geschrieben wurden: dort war der Name zugleich die Dokument-ID,
// beide Seiten des Vergleichs ergeben also weiterhin denselben Schluessel.

/**
 * Bezugsschluessel eines Team-Objekts.
 *
 * `id`      – Team-Dokument aus /teams (die ID ist dort als Feld gespiegelt).
 * `team_id` – reduziertes Team-Objekt aus /public/ergebnisse; dort heisst das
 *             Feld anders, weil die oeffentliche Antwort eine eigene, bewusst
 *             schmale Form hat. Ohne diesen Fall wuerde die oeffentliche
 *             Ergebnisansicht keine Stationsergebnisse mehr zuordnen koennen.
 */
export const teamKey = (t) => (t ? t.id ?? t.team_id ?? t.team_name ?? null : null);

/** Bezugsschluessel eines Ergebnis-/Eintragsobjekts. */
export const resultKey = (r) => (r ? r.team_id ?? r.team ?? r.team_name ?? null : null);

/** Gehoert das Ergebnis zu diesem Team? */
export const gehoertZuTeam = (r, t) => {
  const a = resultKey(r);
  const b = teamKey(t);
  return a != null && b != null && a === b;
};
